import {Localized} from "@fluent/react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material"
import {AppId} from "../../../app/appTypes"
import {Attachements} from "../Attachements"
import {URSRequirement} from "../UrsSlice"
import {BlobResourceType} from "../../documents/blobResourceTypes"
import { RequirementDisplayComponent } from "../components/RequirementDisplayComponent"


interface AttachementsDialogProps {
    onClose       : () => void
    requirementId : AppId
    canUpload     : boolean
    canDelete     : boolean
    group         : string
    typeId        : AppId
    requirement   : URSRequirement
    /** GUID of the owning URS document (the requirement's company-bearing parent). */
    ursGuid       : string
}

export const AttachementsDialog = ({ typeId, requirement, group, onClose, requirementId, canUpload, canDelete, ursGuid} : AttachementsDialogProps) => {
    return <Dialog open={true} fullWidth maxWidth="md">
        <DialogTitle>
            <Localized id="attachements">Załączniki</Localized>
        </DialogTitle>
        <DialogContent>
            <RequirementDisplayComponent requirement={requirement} />
            <Attachements resourceId={requirement.guid} resourceType={BlobResourceType.UrsRequirement} parentResourceId={ursGuid} parentResourceType={BlobResourceType.Document} canUpload={canUpload} canDelete={canDelete}/>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>
                <Localized id="close">Zamknij</Localized>
            </Button>
        </DialogActions>
    </Dialog>
}
